module.exports = __webpack_public_path__ + "img/img-main.a8186811.webp";